import useSWR from 'swr'
import { getRequest } from '../utils/request'

export const getApiVersion = async () => getRequest(`/version`)